module.exports = __webpack_public_path__ + "img/ikclogo.3235abc8.png";